export default __webpack_public_path__ + "images/GH.572df03.png";